const u = (r, e, s) => {
  if (!e)
    return s ? [`${r}--${s}`] : [];
  if (typeof e == "string")
    return [`${r}--${e}`];
  const $ = Object.keys(e).map((t) => `${r}-${t}--${e[t]}`);
  return s && !e.xs ? [`${r}-xs--${s}`, ...$] : $;
}, c = (r) => {
  const e = "iress-p", s = (t) => typeof t == "string";
  return r ? s(r) ? [`${e}--${r}`] : Object.keys(r).some(
    (t) => t === "x" || t === "y" || t === "b" || t === "l"
  ) ? Object.entries(r).map(([t, n]) => `${e}${t}--${n}`) : Object.entries(r).flatMap(([t, n]) => s(n) ? `${e}-${t}--${n}` : Object.entries(n).map(([i, o]) => `${e}${i}-${t}--${o}`)) : [];
};
export {
  u as getResponsiveLayoutModifiers,
  c as getResponsivePaddingClasses
};
